import React from 'react';

export function IconStyle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      fill="none"
      viewBox="0 0 120 120"
			{...props}
    >
      <path
        fill="#fff"
        stroke="#363232"
        strokeWidth="5"
        d="m25.996 5.536 89.417 89.418-20.46 20.46L5.535 25.996z"
      />
      <path
        stroke="#363232"
        strokeWidth="5"
        d="m49.768 32.768-11 11M101.768 84.768l-11 11M36.768 19.768l-11 11M88.768 71.768l-11 11"
      />
      <path
        fill="#fff"
        d="m88.423 16.08 9.862-9.87a10.963 10.963 0 0 1 15.504 15.505l-84.002 84.002a26.307 26.307 0 0 1-11.09 6.606L3 117l4.677-15.697c1.247-4.188 3.517-8 6.606-11.09L88.429 16.08h-.006Zm0 0L103.845 31.5Z"
      />
      <path
        stroke="#363232"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        d="m88.423 16.08 9.862-9.87a10.963 10.963 0 0 1 15.504 15.505l-84.002 84.002a26.307 26.307 0 0 1-11.09 6.606L3 117l4.677-15.697c1.247-4.188 3.517-8 6.606-11.09L88.429 16.08h-.006Zm0 0L103.845 31.5"
      />
      <path
        fill="#363232"
        d="M29.588 109.018a19.999 19.999 0 0 0-18.71-18.325l-.296 4.839a15.151 15.151 0 0 1 14.175 13.883l4.831-.397Z"
      />
      <path
        fill="#323336"
        d="m87.104 16 16.734 16.734-74.082 74.082-16.734-16.734z"
      />
    </svg>
  );
}
